// extracted by mini-css-extract-plugin
export default {"searchArea":"searchbar_searchArea__SVaxW"};